import { useState, useEffect, useRef, useCallback } from 'react';
import ReactAudioPlayer from 'react-audio-player';

import { useAuth, useCourses } from 'contexts';
import { DetailContentInterface } from 'types';
import { getFolderLog, registerFolderLog } from 'services';

import './style.scss';
import { url } from 'inspector';

type AudioProps = {
  content: DetailContentInterface;
  className?: string;
  [key: string]: any;
};

export function Audio({ content, className, ...rest }: AudioProps) {
  const rpRef = useRef<any>();

  const { user } = useAuth();
  const { getFullProgress } = useCourses();

  const [loading, setLoading] = useState(true);
  const [log, setLog] = useState<any>();
  const [ready, setReady] = useState<boolean>(false);
  const [done, setDone] = useState<boolean>(false);
  const [duration, setDuration] = useState(0);
  const [urlAudio, setUrlAudio] = useState<string>('');

  useEffect(() => {
    setDone(false);
    setReady(false);
    setLog(undefined);
  }, [content]);

  useEffect(() => {
    if (!user) return;

    getFolderLog(user._id, content._id)
      .then(data => {
        if (data.length) {
          setLog(data[0]);
        }
      })
      .finally(() => setLoading(false));
  }, [content, user]);

  // useEffect(() => {
  //   if (log?.status === 'in_progress' && log?.extra?.played) {
  //     rpRef.current?.seekTo(log?.extra?.played, 'fraction');
  //   }
  // }, [log]);

  const handleProgress = useCallback(
    (currentTime: number) => {
      if (!user || !ready) return;
      if (!Number.isFinite(duration) || duration <= 0) return;

      const played = currentTime / duration;

      if (!Number.isFinite(played) || played <= 0) return;

      if ((!log || log?.status === 'in_progress') && !done) {
        if (played > 0.95) {
          registerFolderLog(user._id, content._id, 'done').finally(() => {
            getFullProgress();
          });

          setDone(true);
        } else {
          registerFolderLog(user._id, content._id, 'in_progress', { played });
        }
      }
    },
    [content, done, duration, getFullProgress, log, ready, user],
  );

  const handleReady = useCallback(() => {
    if (log?.status === 'in_progress' && log?.extra?.played && duration > 0) {
      rpRef.current.currentTime = log.extra.played * duration;
    }

    if (log?.status === 'done') {
      setDone(true);
    }

    setReady(true);
  }, [log, duration]);

  useEffect(() => {
    if (content.data) {
      if (content.data.url && typeof content.data.url === 'string') {
        setUrlAudio(content.data.url);
      } else if (content.data.file) {
        const fileUrl = typeof content.data.file === 'string' ? content.data.file : content.data.file?.url;
        if (fileUrl && typeof fileUrl === 'string') {
          setUrlAudio(fileUrl);
        }
      }
    }
  }, [content]);

  if (!content || !content.data || loading || !urlAudio) return null;

  return (
    <div className={`audio-component ${className || ''}`}>
      <ReactAudioPlayer
        ref={rpRef}
        src={urlAudio}
        autoPlay
        controls
        onListen={handleProgress}
        onLoadedMetadata={e => setDuration((e.target as HTMLAudioElement).duration)}
        onCanPlay={handleReady}
      />
    </div>
  );
}
